export default __webpack_public_path__ + "static/media/TEXTURA_08.aadccbe8.png";